import { useState } from "react";
import { Logo } from "@repo/ping-design";

export type OrgPickerOrg = { id: string; name: string };

export const OrgPicker = ({
  orgs,
  onSelect,
}: {
  orgs: OrgPickerOrg[];
  onSelect: (orgId: string) => void;
}) => {
  const [joining, setJoining] = useState<string | null>(null);
  const [hovered, setHovered] = useState<string | null>(null);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#F9FAFC",
        fontFamily:
          '"Macan", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: 40,
          maxWidth: 440,
          width: "100%",
          boxShadow: "0 4px 24px rgba(0, 0, 0, 0.08)",
        }}
      >
        <div style={{ marginBottom: 24 }}>
          <Logo />
        </div>
        <h2
          style={{
            margin: "0 0 8px",
            fontSize: "1.4375rem",
            fontWeight: 700,
            color: "#32363D",
          }}
        >
          Select an Organization
        </h2>
        <p
          style={{
            margin: "0 0 28px",
            color: "#9298A0",
            fontSize: "0.9375rem",
            lineHeight: "1.5rem",
          }}
        >
          Your email matches multiple organizations. Choose one to join:
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {orgs.map((org) => {
            const isJoining = joining === org.id;
            const isHovered = hovered === org.id;
            const isDisabled = joining !== null;
            return (
              <button
                key={org.id}
                onClick={() => {
                  setJoining(org.id);
                  onSelect(org.id);
                }}
                onMouseEnter={() => setHovered(org.id)}
                onMouseLeave={() => setHovered(null)}
                disabled={isDisabled}
                style={{
                  padding: "14px 18px",
                  border: isJoining
                    ? "1.5px solid #DE3600"
                    : isHovered && !isDisabled
                      ? "1.5px solid #DE3600"
                      : "1.5px solid #DFE5EF",
                  borderRadius: 10,
                  background: isJoining
                    ? "#FFF2EF"
                    : isHovered && !isDisabled
                      ? "#F9FAFC"
                      : "#fff",
                  cursor: isDisabled ? "default" : "pointer",
                  textAlign: "left" as const,
                  fontSize: "0.9375rem",
                  fontWeight: 500,
                  color: "#32363D",
                  transition: "all 150ms ease",
                  boxShadow:
                    isHovered && !isDisabled
                      ? "0 2px 8px rgba(222, 54, 0, 0.1)"
                      : "none",
                  opacity: isDisabled && !isJoining ? 0.5 : 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>{org.name}</span>
                {isJoining && (
                  <span
                    style={{ fontSize: "0.8125rem", color: "#DE3600" }}
                  >
                    Joining...
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
